// removed by extract-text-webpack-plugin
module.exports = {"root":"root___2t0Xt"};


//////////////////
// WEBPACK FOOTER
// ./src/components_business/ExportDetailModal/Index.less
// module id = A0mP
// module chunks = 18